module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Set Insurer"},"fr":{"title":"Définir l\u0027assureur"}}')
  delete Component.options._Ctor
}
